//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AutoInvoiceDisplayItem } from './AutoInvoiceDisplayItem';
import { ParentDisplayItem } from './ParentDisplayItem';
import { StudentDisplayItem } from './StudentDisplayItem';
import { TagDisplayItem } from './TagDisplayItem';

export class FamilyDisplayItem extends ItemBase {
    Active: boolean = false;
    AutoInvoicePending: boolean | null = null;
    AutoInvoiceSettings: AutoInvoiceDisplayItem | null = null;
    AutoInvoicingEnabled: boolean = false;
    Balance: number | null = null;
    FamilyName: string | null = null;
    ID: string | null = null;
    LastInvoiceDate: string | null = null;
    LastPaymentDate: string | null = null;
    Parents: ParentDisplayItem[] = [];
    StudentNames: string | null = null;
    Students: StudentDisplayItem[] = [];
    TimeZoneDisplayName: string | null = null;
    TimeZoneID: string | null = null;
    PreferredInvoiceRecipientIDs: string[] = [];
    Tags: TagDisplayItem[] = [];

    constructor(initializer?: Partial<FamilyDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "FamilyDisplayItem";
}
